// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"894":"cf6ad787","909":"f43036b4"}[chunkId] + ".chunk.js";
};